export const config = {apiUrl: 'https://lesewert.herokuapp.com/api/v1'};
